var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"print-button",attrs:{"size":"lg","variant":"icon","title":_vm.$translate('print')},on:{"click":_vm.openPrintPreview}},[_c('router-link',{attrs:{"to":{
            name: _vm.ROUTES.PRINT_WELL,
            params: _vm.$route.params
        },"target":"_blank"}},[_c('print-icon')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }